<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-alert
                        title="This function is still under development. Feedback is welcome."
                        type="info"
                        center
                        show-icon>
                </el-alert>
                <br/>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="18" :offset="3">
                <el-form
                        ref="form"
                        :model="form"
                        label-width="160px"
                        :rules="rules"
                >
                    <el-form-item label="Place (Depot)" prop="placeId">
                        <el-select
                                class="el-form-item-inside"
                                v-model="form.placeId"
                                placeholder="Please select a place (depot)"
                                filterable
                        >
                            <el-option
                                    v-for="place in places"
                                    :label="place.name"
                                    :key="place.id"
                                    :value="place.id"
                            >
                                <span>{{place.name}}</span>
                                <span style="float:right;color:#ccc">{{place.address_readable}}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Dates" prop="dates">
                        <el-date-picker
                                v-model="form.dates"
                                type="daterange"
                                unlink-panels
                                range-separator="To"
                                start-placeholder="StartDate"
                                end-placeholder="End Date"
                                :picker-options="pickerOptions"
                                :default-time="['00:00:00', '23:59:59']"
                                class="el-form-item-inside">
                        </el-date-picker>
                    </el-form-item>
                    <!-- Buttons -->
                    <el-form-item>
                        <el-button type="success" @click="handleSubmit('form')" :loading="isExporting">{{submitButtonText}}</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'ScheduleMonitorKpiExporter',
        props: {},
        data () {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: 'One Week',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'One Month',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                rules: {
                    placeId: [
                        { required: true, type: 'string', message: 'Please select a place (depot)', trigger: 'blur' }
                    ],
                    dates: [
                        { required: true, type: 'array', message: 'Please select the dates', trigger: 'blur' }
                    ],
                },
                form: {
                    dates: '',
                    placeId: '',
                }
            }
        },
        methods: {
            handleSubmit (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        const params = {
                            place_id: this.form.placeId,
                            start_date: this.form.dates[0],
                            end_date: this.form.dates[1],
                        };
                        this.$store.dispatch('exportSchedulesKpiReport', params)
                            .then(res => {
                                const fileName = res.data.data.file_name;
                                console.log(fileName);
                                window.location.href = '/carry-freight/schedules-kpi-reports/' + fileName;
                            }).catch(err => {
                                this.$message.error('Sorry, failed to generate the KPI report.');
                        });
                    } else {
                        this.$message.error('Sorry, failed to generate the KPI report.');
                    }
                })
            },
        },
        computed: {
            places: function () {
                return this.$store.getters.getPlaces;
            },
            isExporting: function () {
                return this.$store.getters.getSchedulesKpiReportExportStatus === 1;
            },
            submitButtonText: function () {
                return this.isExporting? 'Exporting' : 'Export';
            }
        },
        mounted() {
        }
    };
</script>

<style scoped>
    .el-form-item-inside {
        width: 80%;
        max-width: 500px;
    }
</style>